import React from 'react';
import MarketOverviewV2 from './v2/MarketOverviewV2';
import { isMarketV2Data } from './adapters/marketV2Adapter';
import LegacyMarketOverview from '../MarketOverview';

function readQueryParam(name) {
  if (typeof window === 'undefined') return null;
  return new URLSearchParams(window.location.search).get(name);
}

export default function MarketOverviewResolver({ data, forceV2, forceLegacy, allowAnyRegions, ...rest }) {
  const qp = readQueryParam('market_v2');
  const forceParamV2 = qp === '1';
  const forceParamLegacy = qp === '0';
  const envFlag = process.env.REACT_APP_ENABLE_MARKET_V2 === 'true';

  if (forceLegacy || forceParamLegacy) return <LegacyMarketOverview marketOverview={data} {...rest} />;

  const isV2 = !!(forceV2 || forceParamV2 || envFlag || isMarketV2Data(data));
  return isV2 ? (
    <MarketOverviewV2 data={data} allowAnyRegions={allowAnyRegions} {...rest} />
  ) : (
    <LegacyMarketOverview marketOverview={data} {...rest} />
  );
}
